export enum ApiStatusTypePrefix {
    Begin = "INITIAL",
    Success = "SUCCESS",
    Fail = "FAILED",
}
